const clickBtn = document.querySelector('.facets__list');

let resetAll = document.querySelector('.facets__reset');
resetAll.addEventListener('click',function(e){
	localStorage.removeItem('updated_url');
});

let clear_all = document.querySelectorAll('.active-facets__button-remove');
clear_all.forEach( cc =>{
  
    cc.addEventListener('click',function(e){	
  	localStorage.removeItem('updated_url');
	});
  
});


function filter_url_reload(urls){
  	   
  	   let url = '?';
  	   let filter_urls = urls.split(",").filter(v=>v!='');
  
  	   filter_urls.forEach( filter_val => {
         url += `filter.p.product_type=${filter_val}&`;
       });
  
      window.location.assign(`https://thelipbar.com/collections/shop-all${url}`);
}

clickBtn.addEventListener('click',function(e){
  
		let currentCheckbox = e.target.closest('input[type="checkbox"]');
  		if(currentCheckbox == null) return;
  		
  		let url = [];
  		url.push(localStorage.getItem('updated_url'));
  
  		if(currentCheckbox.checked == true){
          
		  url.push(currentCheckbox.getAttribute('value'));
          localStorage.setItem('updated_url', url);
          
          let get_local_url = localStorage.getItem('updated_url');
          filter_url_reload(get_local_url);

          
        }else{
          
          let remove_value = currentCheckbox.getAttribute('value');
		  let updated_urls = localStorage.getItem('updated_url').replaceAll(remove_value,"");
          
          localStorage.setItem('updated_url',updated_urls);
          filter_url_reload(updated_urls);
          
        }
  		
});